import type { IntegrationListItemType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { useForm } from "react-hook-form";
import { Icon } from "../../../../components";
import { InputText, SmallButton } from "@sellar-io/components";
import {
  TableLegacyTR,
  TableLegacyTD,
} from "../../../../components/table/TableLegacy";
import {
  getIntegrationName,
  getIntegrationPlaceholder,
} from "./ConnectionIntegrationValuesRow.shared";

export function ConnectionIntegrationValuesRow({
  integration,
  onSubmit,
  loading,
}: {
  integration: IntegrationListItemType;
  onSubmit: (value: string) => void;
  loading: boolean;
}): ReactElement | null {
  const {
    register,
    getValues,
    formState: { isDirty },
  } = useForm<{ value: string | undefined }>({
    defaultValues: {
      value: integration.SupplierRetailerConnectionIntegrationValues[0]?.value,
    },
    shouldUseNativeValidation: true,
  });

  const getUrlGuide = () => {
    switch (integration.type) {
      case "xero": {
        return "https://sellar.notion.site/How-to-find-your-customer-s-Contact-ID-in-Xero-e038e49d71904cb09e91e0bd70284c3a";
      }
      case "quickbooks": {
        return "https://sellar.notion.site/How-to-find-your-customer-s-Customer-ID-in-Quickbooks-78747cc055e64f5d86c865403ae71c1a";
      }
      case "freeagent": {
        return "https://sellar.notion.site/How-to-find-your-customer-s-Contact-ID-in-FreeAgent-dd747b782f644697a0e103dc97de5ed6";
      }
      default: {
        return null;
      }
    }
  };

  return (
    <TableLegacyTR key={integration.id}>
      <TableLegacyTD>{getIntegrationName(integration)}</TableLegacyTD>
      <TableLegacyTD>
        <InputText
          {...register("value", { required: true })}
          placeholder={getIntegrationPlaceholder(integration)}
        />
      </TableLegacyTD>
      <TableLegacyTD>
        <SmallButton
          disabled={!isDirty}
          loading={loading}
          onClick={() => onSubmit(getValues("value") ?? "")}
        >
          Update
        </SmallButton>
      </TableLegacyTD>
      <TableLegacyTD>
        <SmallButton
          color={"secondary"}
          onClick={() => window.open(getUrlGuide() ?? "", "_blank")}
        >
          <Icon icon={"OPEN_IN_NEW"} />
          How do I find this?
        </SmallButton>
      </TableLegacyTD>
    </TableLegacyTR>
  );
}
